<!-- <a (click)="selectedPresc(inputData)" *ngIf="!isAllToShow && !showPrescName">
    <div class="card prescriber-card">
        <div class="drug-row-no">{{index+1}}</div>
        <div class="col-lg-12">
            <div class="row">
                <div class="col-md-11">
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <div class="card__subTit--head">
                                    {{
                                        "prescriber-result-card.Prescriber_Name"
                                            | translate
                                    }}
                                </div>
                                <div class="card__subTit--title">
                                    <span appHighlight    [searchedWords]="searchTerm.split(',')[0]" [text]='inputData?.prescriberlastname | uppercase'></span>,
                                    <span appHighlight  [searchedWords]="searchTerm.split(',')[1] ? searchTerm.split(',')[1].trim() : searchTerm" [text]='inputData?.prescriberfirstname | uppercase'></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-9 word_Space_Pre_Line">
                            <div class="row">
                                <div class="card__subTit--head">
                                    {{
                                        "prescriber-result-card.Prescriber_Address"
                                            | translate
                                    }}
                                </div>
                                <div class="card__subTit--title">
                                    {{
                                        (PrescAddress?.AddressLine1
                                            ? PrescAddress?.AddressLine1 + ","
                                            : "") | uppercase
                                    }}
                                    {{
                                        (PrescAddress?.AddressLine2
                                            ? PrescAddress?.AddressLine2 + ","
                                            : "") | uppercase
                                    }}
                                    {{
                                        (PrescAddress?.CityName
                                            ? PrescAddress?.CityName + ","
                                            : "") | uppercase
                                    }}
                                    {{
                                        (PrescAddress?.StateName
                                            ? PrescAddress?.StateName + ","
                                            : "") | uppercase
                                    }}
                                    {{
                                        PrescAddress?.ZipCode
                                            ? PrescAddress?.ZipCode
                                            : ""
                                    }}
                                </div>
                            </div>
                        </div>

                        <div class="col-3 space_overflow">
                            <div class="row">
                                <div class="card__subTit--head">
                                    {{ "prescriber-result-card.License" | translate }}
                                </div>
                                <div class="card__subTit--title">
                                    <span appHighlight  [searchedWords]="searchTerm" [text]='inputData?.prescriberlicensenumber ? inputData?.prescriberlicensenumber : ""'></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <div class="card__subTit--head">
                                    {{ "prescriber-result-card.DEA" | translate }}
                                </div>
                                <div class="card__subTit--title">
                                    <span appHighlight   [searchedWords]="searchTerm" [text]='(_formatsUtil.getDeaFormat(inputData?.prescriberdeanum)) | uppercase'></span>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="row">
                                <div class="card__subTit--head">
                                    {{ "prescriber-result-card.NPI" | translate }}
                                </div>
                                <div class="card__subTit--title">
                                    <span appHighlight   [searchedWords]="searchTerm" [text]='inputData?.prescribernpinum'></span>
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="row">
                                <div class="card__subTit--head">
                                    {{ "prescriber-result-card.Phone" | translate }}
                                </div>
                                <div class="card__subTit--title">
                                    <span appHighlight [fromPhone]="true" [searchedWords]="searchTerm ? (searchTerm | mask : '[(]000[)]000-000000000' ) : ''"
                                    [searchWithText] = "inputData?.telephone && inputData?.telephone !== '###' ? inputData?.telephone : ''" [searchWord2]="searchTerm"
                                    [text]='inputData?.telephone && inputData?.telephone !== "###" ? (inputData?.telephone | mask : "(000)000-0000" ) : " "'></span>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="row">
                                <div class="card__subTit--head">
                                    {{ "prescriber-result-card.QuickCode" | translate }}
                                </div>
                                <div class="card__subTit--title">
                                    {{inputData?.prescriberquickcode ? inputData?.prescriberquickcode : ''}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-1 padding-0 prescriber--icon">
                    <i class="far fa-user-md doc--icon" aria-hidden="true"></i>
                </div>
            </div>
        </div>
    </div>
</a> -->

<!-- <a (click)="selectedPresc(inputData)" *ngIf="showPrescName">
    <div class="card prescriber-card">
        <div class="row">
            <div class="col-md-11">
                <div class="row">
                    <div class="col">
                        <div class="row">
                            <div class="card__subTit--title">
                                {{
                                    inputData?.prescriberlastname +
                                        ", " +
                                        inputData?.prescriberfirstname
                                }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a> -->



<div>
    <div *ngIf="isPopUp" class="modal-header">
        <div class="row">
            <div class="col"><span class="eprx--header__heading font_weight_600 pt-1">Prescriber Search</span></div>
            <button type="button" [tabindex]="-1" class="close" aria-label="Close"  (click)="closePrescriberModal()">
                <span aria-hidden="true" class="close-button">&times;</span>
            </button>
        </div>
    </div>
    <div class="row erx--drug-body">
        <div class="col-md-12" [ngClass]="searchFrmPage === 'Dash' && !isPopUp ? 'dash--drug--grid' : searchFrmPage === 'header' && !isPopUp ? 'notdash--drug--grid' : ''">
            <div class="exprx--common-block">
                <div class="eprx--block__header block__header" *ngIf="!isPopUp">
                    <div class="row">
                        <div class="col"><span class="eprx--header__heading pt-1">Prescriber Search</span></div>
                        <button type="button" [tabindex]="-1" class="close pr-3 pt-1" aria-label="Close" (click)="ClosePatientDrugPage.emit(true); clearFilters()">
                            <span aria-hidden="true" class="close-button">&times;</span>
                        </button>
                    </div>
                </div>
                <div class="eprx--block__content block__content erx--body p-4">
                    <div class="row">
                        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
                            <div class="d-flex flex-column pt-1">
                                <eprx-input [AutoFocus]="true" [LabelText]="'Search'" [ControlName]="'PrescriberName'" [FormGroupName]= "PrescriberSuggestFilterFG" [PlaceHolder]="'Enter Keywords, Prescriber names, or Address to search through the list below and globally'" (TriggerValWhileEnter)= "getPrescriberBySearch()" [RxSelectId]= "'PatientName'" (TriggerOnEnterValue)= "getGlobalSearchPrescriberSuggest()">
                                </eprx-input>
                                <span class="help-block" *ngIf="required"> Enter min 3 Chars </span>
                                <div class="search--icon" (click)="clearedBySearchIcon()">
                                    <i class="far fa-search"></i>
                                </div>                            
                            </div>
                        </div>
                         <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 padding_top_27px">
                            <div class="row">
                                <div class="col-md-5">
                                    <label class="form-check-label padding_top_0_1rem">Show Active Prescibers Only</label>
                                </div>
                                <div class="col-md-4">
                                    <eprx-toggle [LabelText]="''" [ControlName]="'ActivePrescriber'" [FormGroupName]= "PrescriberSuggestFilterFG" [IsChecked]= "PrescriberSuggestFilterFG?.get('ActivePrescriber')?.value" 
                                    [RxselectId]="'IsActivePrescriber'" (TriggerSelectValue)="getActivePrescriberList($event.target.checked)"></eprx-toggle>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 align-button text-right allign-bottom">
                            <button type="submit" #searchButton title="Search" class="hotkey_success pull-right" appShortcutKey appShortcutKey [AltKey]="'f'" (click)="getGlobalSearchPrescriberSuggest()">
                                <span>F</span> Search
                            </button>
                            <button type="button" class="hotkey_success pull-right" appShortcutKey [AltKey]="'l'" (click)="clearFilters()">
                                <span>L</span> clear
                            </button>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div id="loader" class="progress-bar-container mb-2" *ngIf="loading">
                            <div class="progress-bar--common" [style.width]="progressValue + '%'"></div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 drugwj-grid">
                            <wj-flex-grid #prescriberflex [columnPicker]="'prescriberSuggestListWj'" [itemsSource]= "prescriberSuggestWJ" [isReadOnly]="true"  [allowSorting]="true" (initialized)= "Init(prescriberflex)" [ngClass]="!prescriberSugList?.length ? 'no-data':''" [itemFormatter]= "itemFormatter"
                            [headersVisibility]="'Column'" [selectionMode]="'Row'" (click)="onRowSingleClick(prescriberflex, $event)" class="text_transform" (drop)="_storageService.storeWijmoGridDataInSession(prescriberflex)" (resizedColumn)="_storageService.storeWijmoGridDataInSession(prescriberflex)" (keydown.tab)="focusToFirst($event)">
                            <wj-flex-grid-column [header]="''" [width]="40">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-row="row" let-item="item" let-cell="cell">
                                    <span class="text-center">
                                        <input class="form-check-input drug-check-input ml-0" type="checkbox" [(ngModel)]="item.isSelected" [disabled]="item?.activestatusid !=1" [checked]="item.isSelected" [id]="item.RowId" name="" (click)="getselectedPrescriberByCheck(item)"/>
                                        <label class="form-check-label" [for]="item.RowId"></label>
                                    </span>
                                </ng-template>
                            </wj-flex-grid-column>
                            <wj-flex-grid-column [header]="rxheader['hName']" [binding]="rxheader['hName']" [visible]="rxheader['isVisible']"
                                    *ngFor="let rxheader of prescriberListwjHeaders; let i = index" [width]="rxheader['width']">
                                    <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item" let-cell="cell">
                                        <div [ngbTooltip]="item?.activestatusid !=1 && rxheader['hName'] === 'Prescriber Name' ? 'Inactive' : (rxheader['hName'] === 'Prescriber Name' || rxheader['hName'] === 'Address' ? prescribercellToolTip : '')" [placement] = "(cell.col.index>=0 && cell.col.index < 2) ? 'right' : (cell.col.index>=2 && cell.col.index <5)?'top':'left'" triggers="mouseover:mouseleave" container="body" tooltipClass="tooltip-title">
                                            {{item[rxheader['hName']]}}                                        
                                        </div>
                                        <ng-template #prescribercellToolTip>
                                            <span>{{item[rxheader['hName']] | uppercase}}</span>
                                    </ng-template>
                                    </ng-template>
                                    <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-item="item">
                                        <div [title]="rxheader['hName']">
                                            {{ rxheader['hName'] }}
                                        </div>
                                    </ng-template>                                
                            </wj-flex-grid-column>
                            <app-no-data-found *ngIf="!prescriberSugList?.length"></app-no-data-found>
                            </wj-flex-grid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
